export const IconGrid = ({ isActive = false }) => {
  return (
    <svg
      width="12"
      height="12"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <rect
        x="3"
        y="3"
        width="8"
        height="8"
        fill={isActive ? "#323133" : "#BDBDBD"}
      />
      <rect
        x="13"
        y="3"
        width="8"
        height="8"
        fill={isActive ? "#323133" : "#BDBDBD"}
      />
      <rect
        x="3"
        y="13"
        width="8"
        height="8"
        fill={isActive ? "#323133" : "#BDBDBD"}
      />
      <rect
        x="13"
        y="13"
        width="8"
        height="8"
        fill={isActive ? "#323133" : "#BDBDBD"}
      />
    </svg>
  );
};
